<template>
  <div>
    <CRow>
      <CCol col="12" v-if="facilityList == null || facilityList.length === 0">
        <CAlert show color="light" class="">
          <p class="mt-2 mb-2 font-weight-bold" style="font-size: 14px">
            등록된 농장이 없습니다 <br />
            농장을 추가해주세요
          </p>
        </CAlert>
      </CCol>

      <CCol md="12">
        <CCard>
          <CCardBody>
            <CButton
              type="button"
              size="sm"
              color="outline-primary"
              style="width: 100%"
              @click="showAddModal()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i>
              농장 추가
            </CButton>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol md="12">
        <CCard v-for="(facility, index) in facilityList" :key="index">
          <CCardHeader style="line-height: 2.3">
            <strong> {{ facility.name }} </strong>
            <div class="card-header-actions">
              <CButton
                type="button"
                size="sm"
                color="outline-warning"
                @click="showEditModal(facility)"
              >
                <i class="fa fa-pencil" aria-hidden="true"></i>
                수정
              </CButton>
              <CButton
                type="button"
                size="sm"
                color="outline-danger"
                class="ml-2"
                @click="deleteFacility(facility)"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
                삭제
              </CButton>
            </div>
          </CCardHeader>
          <CCardBody>
            <table class="table table-borderless">
              <tbody>
                <tr>
                  <td class="font-weight-bold">REST API URL</td>
                  <td style="word-break: break-all" colspan="4">
                    http://222.105.187.66:52324/api/v1/facility/{{
                      facility.id
                    }}/internal-facility/{dongNo}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">인증키</td>
                  <td style="word-break: break-all" colspan="3">
                    {{ facility.authKey }}
                  </td>
                  <td style="min-width: 90px">
                    <CButton
                      size="sm"
                      color="outline-primary"
                      class="ml-2"
                      @click="refreshAuthKey(facility)"
                    >
                      재발급
                    </CButton>
                  </td>
                </tr>
                <tr>
                  <td
                    class="font-weight-bold"
                    style="width: 15%; min-width: 90px"
                  >
                    시설유형
                  </td>
                  <td style="word-break: break-all">
                    {{ dongTypeFormat(facility.dongType) }},
                    {{ facility.dongSize }}개 동
                  </td>
                </tr>
                <tr>
                  <td
                    class="font-weight-bold"
                    style="width: 15%; min-width: 90px"
                  >
                    작물
                  </td>
                  <td style="word-break: break-all">{{ facility.cropName }}</td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <AddEditFarmModal
      :properties="modal.addEdit"
      v-if="modal.addEdit.visible"
    ></AddEditFarmModal>
  </div>
</template>

<script>
import AddEditFarmModal from "@/modals/facility/AddEditFacilityModal";
import FacilityService from "@/services/facility/facility.service";
import core from "@/core";
import axios from "axios";

export default {
  name: "Farm",
  components: {
    AddEditFarmModal,
  },
  data() {
    return {
      facilityList: [],
      modal: {
        addEdit: {
          visible: false,
          params: {
            type: "add",
            item: null,
          },
          watchClose: {
            result: "",
          },
        },
      },
    };
  },
  created() {
    this.getFacilityList();
  },
  mounted() {
    // const app = store.state.app;
    // if (app.facilityList.length === 0) {
    //   core.alert.show({
    //     title: "확인",
    //     body: `등록된 농장이 없습니다<br/>농장을 추가해주세요`,
    //     confirmButtonText: "확인",
    //   });
    // }
  },
  watch: {
    "modal.addEdit.watchClose"() {
      const modal = this.modal.addEdit;
      const event = modal.watchClose;
      if (event.result === "confirm") {
        this.getFacilityList();
      }
    },
  },
  methods: {
    showEditModal(facility) {
      const modal = this.modal.addEdit;
      modal.params.type = "edit";
      modal.params.item = facility;
      modal.visible = true;
    },
    showAddModal() {
      const modal = this.modal.addEdit;
      modal.params.type = "add";
      modal.visible = true;
    },
    async deleteFacility(facility) {
      const result = await core.alert.show({
        title: "확인",
        body: `"${facility.name}" 농장을 삭제하시겠습니까?`,
        showCancelButton: true,
        cancelButtonText: "아니오",
        confirmButtonText: "예",
      });
      if (result === "confirm") {
        try {
          axios.post("/db/delete_CropInfo", facility);
          const apiResult = await FacilityService.delete(facility.id);
          this.getFacilityList();
        } catch (e) {
          console.log(e);
        }
      }
    },
    async refreshAuthKey(facility) {
      const result = await core.alert.show({
        title: "확인",
        body: `"${facility.name}" 농장 인증키를 재발급 하시겠습니까?`,
        showCancelButton: true,
        cancelButtonText: "아니오",
        confirmButtonText: "예",
        allowBackCloseEvent: true,
      });
      if (result === "confirm") {
        try {
          const apiResult = await FacilityService.generatorAuthKey(facility.id);
          this.getFacilityList();
        } catch (e) {
          console.log(e);
        }
      }
    },
    dongTypeFormat(type) {
      if (type === "S") return "단동";
      else if (type === "M") return "연동";
      return "";
    },
    async getFacilityList() {
      core.loader.show();

      try {
        const facilityList = await FacilityService.getList();
        // console.log("facilityList : ", facilityList);
        this.facilityList = facilityList;
        const app = this.$store.state.app;
        if (app.facilityId == null && facilityList.length > 0) {
          app.facilityId = facilityList[0].id;
        }
      } catch (e) {
        console.log(e);
      }
      core.loader.hide();
    },
  },
};
</script>
